/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Siparis_IptalInputs */

const tr_faq_q_siparis_iptal = /** @type {(inputs: Faq_Q_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş iptalini nasıl yapabilirim?`)
};

const en_faq_q_siparis_iptal = /** @type {(inputs: Faq_Q_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I cancel an order?`)
};

const de_faq_q_siparis_iptal = /** @type {(inputs: Faq_Q_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie storniere ich eine Bestellung?`)
};

const ru_faq_q_siparis_iptal = /** @type {(inputs: Faq_Q_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как отменить заказ?`)
};

/**
* | output |
* | --- |
* | "How do I cancel an order?" |
*
* @param {Faq_Q_Siparis_IptalInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_siparis_iptal = /** @type {((inputs?: Faq_Q_Siparis_IptalInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Siparis_IptalInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_siparis_iptal(inputs)
	if (locale === "de") return de_faq_q_siparis_iptal(inputs)
	if (locale === "ru") return ru_faq_q_siparis_iptal(inputs)
	return tr_faq_q_siparis_iptal(inputs)
});